import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import SearchFilter from '@/v2/my-create/social-media-posting/components/search-filter.vue';
import ResourceGridView from '@/entities/resource-management/resource-grid-view/resource-grid-view.vue';
import BriefingService from '@/service/briefing.service';
import { BriefingResourceItem, IResourceModel } from '@/shared/model/briefing-widget.model';
import { map2ResourceItem } from '@/util/mapper-utils';
import ListLoadingComponent from '@/entities/resource-management/list-loading/list-loading.vue';
import NoData from '@/v2/discovery/NoData.vue';
import NoDataComponent from './components/no-data-component.vue';
import { MY_CREATE_TYPES, REPORT_TOAST_STATUS } from '@/constants';
import SearchEmpty from '@/v2/shared/search/search-empty.vue';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({
  computed: {
    MY_CREATE_TYPES() {
      return MY_CREATE_TYPES;
    },
  },
  components: {
    SearchEmpty,
    NoDataComponent,
    NoData,
    'search-filter': SearchFilter,
    'resource-grid-view': ResourceGridView,
    'list-loading': ListLoadingComponent,
  },
})
export default class MyCreateSocial extends Vue {
  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @appStoreState.Getter
  public getToastReportData!: any;

  resourceItems: IResourceModel[] = [];
  loading = false;
  currentPage = 0;
  isActivated = true;
  loadMoreAble = true;
  loadMoreReport = true;
  pageSize = 20;
  total: 0;
  fetchCount = 1;
  filterPayload: any = {
    userKey: null,
    userKeyCheckBookMark: null,
    language: null,
    bpId: null,
    bpIds: [],
    documentType: ['REPORT'],
    briefingType: ['REPORT_PAGE', 'MY_CREATES'],
    briefingPrivacy: null,
    contentType: ['MYCONTENT'],
    mediaType: ['SOCIAL_MEDIA', 'SOCIAL_MEDIA_BLOG', 'SOCIAL_MEDIA_FACEBOOK', 'SOCIAL_MEDIA_X', 'SOCIAL_MEDIA_YOUTUBE'],
    startDate: null,
    endDate: null,
  };
  loadingList: IResourceModel[] = [];

  public get userIdentity(): any {
    return (
      this.$store.getters?.account || this.$store.getters?.userIdentity || JSON.parse(localStorage.getItem('localStorageUser') || 'null')
    );
  }

  get thisReportList(): IResourceModel[] {
    return this.resourceItems;
  }

  isNoData = false;

  mounted() {
    this.filterPayload.userKey = this.userIdentity?.id || null;
    this.loadInitialData();
  }

  loadInitialData() {
    this.currentPage = 0;
    this.resourceItems = [];
    this.fetchData(this.filterPayload, this.currentPage);
  }

  // @Watch('resourceItems')
  // onResourceItemsChanged(value: any) {
  //   //this.fetchStatistics(this.filterPayload, this.currentPage);
  // }

  @Watch('currentPage')
  onCurrentPageChanged(value: number) {
    this.fetchData(this.filterPayload, value);
  }

  fetchStatistics(filterPayload: any, page: number) {
    const language = filterPayload.language == null ? ['ALL'] : [filterPayload.language];
    this.briefingService()
      .getAllBriefingDataForMycreate(
        null,
        ['REPORT'],
        ['MYCONTENT'],
        ['MY_CREATES'],
        null,
        filterPayload.startDate,
        filterPayload.endDate,
        language,
        false,
        this.loadMoreReport,
        page,
        this.pageSize,
        filterPayload.userKey,
        filterPayload.userKey,
        null,
        filterPayload.mediaType,
        filterPayload.keyword
      )
      .then(resp => {
        this.total = resp.data?.body?.body?.totalElements || 0;
      })
      .catch(() => {
        // this.resourceItems = [];
        this.total = 0;
      });
  }

  @Watch('getToastReportData', { immediate: true })
  onGetToastReportData() {
    this.getToastReportData.forEach(data => {
      const targets = [
        'SOCIAL_MEDIA',
        'SOCIAL_MEDIA_BLOG',
        'SOCIAL_MEDIA_FACEBOOK',
        'SOCIAL_MEDIA_X',
        'SOCIAL_MEDIA_YOUTUBE',
        'SOCIAL_MEDIA_POSTING',
      ];
      if (
        targets.some(type => data.type === type) &&
        data.status === REPORT_TOAST_STATUS.LOADING &&
        !this.loadingList.some(item => item.requestId === data.requestId)
      ) {
        const loadingData: IResourceModel = {
          requestId: data.requestId,
          isLoadingCard: true,
          docId: '',
          type: 'SOCIAL_MEDIA',
        };
        this.loadingList.push(loadingData);
      }
      if (data.status === REPORT_TOAST_STATUS.SUCCESS) {
        this.loadingList = this.loadingList.filter(item => item.requestId !== data.requestId);
      }
    });
  }

  fetchData(filterPayload: any, page: number) {
    // if (filterPayload&&filterPayload.keyword&&filterPayload.keyword.trim()!=''){
    //   this.getMyReport(filterPayload, page);
    // }else{
    //   this.getAllResourceData(filterPayload, page);
    // }
    if (!filterPayload?.keyword?.trim()) {
      this.fetchCount = 1;
    } else {
      this.fetchCount = this.fetchCount + 1;
    }

    // this.fetchCount = this.fetchCount + 1;
    this.getData(filterPayload, this.currentPage);
  }

  handleFilterChange(filter: { tab: string; keyword: string }) {
    const data = ['SOCIAL_MEDIA', 'SOCIAL_MEDIA_BLOG', 'SOCIAL_MEDIA_FACEBOOK', 'SOCIAL_MEDIA_X', 'SOCIAL_MEDIA_YOUTUBE'];
    let keywordData = filter.keyword;
    if (!filter.keyword || filter.keyword.trim().length == 0) {
      keywordData = null;
    }
    // if (!filter.tab || filter.tab == 'ALL') {
    //   data = null;
    // } else if (filter.tab === 'COMPARISON') {
    //   data = ['PRODUCT_REVIEW', 'PRODUCT_REVIEW_BLOG'];
    // } else {
    //   data = [filter.tab];
    // }
    this.filterPayload = {
      ...this.filterPayload,
      mediaType: data,
      keyword: keywordData,
      // bạn có thể truyền thêm keyword, tab filter vào đây nếu cần
    };
    this.loadInitialData();
  }

  handleChangeDate({ startDate, endDate }: { startDate: string; endDate: string }) {
    console.log('handleChangeDate', startDate, endDate);

    this.filterPayload.startDate = startDate;
    this.filterPayload.endDate = endDate;
    this.currentPage = 0;
    this.loadInitialData();
  }

  handleChangeLanguage({ lang }: { lang: string }) {
    console.log('handleChangeLanguage', lang);
    if (!lang || lang == 'all') {
      this.filterPayload.language = null;
    } else {
      this.filterPayload.language = lang;
    }
    this.currentPage = 0;
    this.loadInitialData();
  }

  /**
   * Sự kiện scroll-to-end từ resource-grid-view
   */
  onLoadMore() {
    if (!this.loading && this.loadMoreAble) {
      this.currentPage++;
      this.fetchData(this.filterPayload, this.currentPage);
    }
  }

  getData(filterPayload: any, page: number): void {
    if (this.loading) return;

    this.loading = true;
    this.loadMoreAble = false;
    const language = filterPayload.language == null ? ['ALL'] : [filterPayload.language];
    this.briefingService()
      .getAllBriefingDataForMycreate(
        null,
        ['REPORT'],
        ['MYCONTENT'],
        ['MY_CREATES'],
        null,
        filterPayload.startDate,
        filterPayload.endDate,
        language,
        false,
        this.loadMoreReport,
        page,
        this.pageSize,
        filterPayload.userKey,
        filterPayload.userKey,
        null,
        filterPayload.mediaType,
        filterPayload.keyword
      )
      .then(resp => {
        this.loadMoreReport = resp.data.body.body.moreReport;
        this.total = resp.data?.body?.body?.totalElements || 0;
        const briefingData = resp.data.body.body.discoveryReportDTO.listBriefingData;

        if (briefingData?.length) {
          // const mapped = briefingData
          //   .filter((item: BriefingResourceItem) => item.parentDocDetail)
          //   .map(map2ResourceItem);
          // this.resourceItems.push(...mapped);
          this.resourceItems = [
            ...this.resourceItems,
            ...briefingData.filter((item: BriefingResourceItem) => item.parentDocDetail).map(map2ResourceItem),
          ];
        }
        this.loadMoreAble = this.loadMoreReport;
      })
      .catch(() => {
        this.loadMoreAble = false;
        this.resourceItems = [];
        this.total = 0;
      })
      .finally(() => {
        this.isNoData = this.resourceItems.length === 0;
        this.loading = false;
      });
  }

  onChangeBookmark(params: any) {
    this.$emit('onChangeBookmark', params);
  }
}
